import Swal from 'sweetalert2';
import { Fragment } from 'react';
import ReactDOM from 'react-dom';
import Loader from '../Components/Loader';

var url_json = require("../location.json");

if (window.location.origin.includes("localhost")) {
    url_json = url_json.local;
} else {
    url_json = url_json.production;
}

const Calendario = {
    agregarEvento: async (data) => {
        ReactDOM.render(
            <div className='loader_padre'>
                <Loader />
            </div>,
            document.getElementById("loader_padre")
        );

        let url = url_json + "/evento"
        let body = {
            dia: data.dia,
            mes: data.mes,
            anio: data.anio,
            fecha: data.fecha,
            color: data.color,
            evento: data.evento
        };
        let request = {
            method: 'POST',
            body: JSON.stringify(body),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let res = await response.json();

        ReactDOM.render(
            <Fragment></Fragment>,
            document.getElementById("loader_padre")
        );

        if (response.ok) {
            Swal.fire(
              'Inserción exitosa!',
              'Evento agregado correctamente' ,
              'success'
            ).then(() => {
              window.location.reload();
            })
        } else {
            Swal.fire(
                'Error!',
                'No se pudo guardar el evento, codigo: ' + res.message ,
                'error'
            ).then(() => {
                window.location.reload();
            })
        }
        return { success: response.ok, data: res.data, code: res.message };
    },
    obtenerEventos: async () => {
        let url = url_json + "/evento"
        let request = {
            method:'GET',
            headers: {
                "Content-type":"application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    obtenerUnEvento: async id => {
        let url = url_json + "/evento/" + id
        let request = {
            method:'GET',
            headers: {
                "Content-type":"application/json; charset=UTF-8"
            }
        }

        let response = await fetch(url, request);
        let json = await response.json();
        return { success: response.ok, data: json.data, code: json.message };
    },
    editarEvento: async (data, id) => {
        Swal.fire({
            icon: "question",
            title: '¿Esta seguro que desea modificar el evento?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Si',
            denyButtonText: `No`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                ReactDOM.render(
                    <div className='loader_padre'>
                        <Loader />
                    </div>,
                    document.getElementById("loader_padre")
                );

                let url = url_json + "/evento/" + id;

                let body = {
                    dia: data.dia,
                    mes: data.mes,
                    anio: data.anio,
                    fecha: data.fecha,
                    color: data.color,
                    evento: data.evento
                };
                let request = {
                    method: 'PATCH',
                    body: JSON.stringify(body),
                    headers: {
                        "Content-type": "application/json; charset=UTF-8"
                    }
                }

                let response = await fetch(url, request);
                let res = await response.json();

                ReactDOM.render(
                    <Fragment></Fragment>,
                    document.getElementById("loader_padre")
                );

                if (response.ok) {
                    Swal.fire(
                        'Modificación exitosa!',
                        'Evento modificado correctamente' ,
                        'success'
                    ).then(() => {
                        window.location.reload();
                    })
                } else {
                    Swal.fire(
                        'Error!',
                        'No se pudo modificar el evento' ,
                        'error'
                    ).then(() => {
                        window.location.reload();
                    })
                }
                return { success: response.ok, data: res.data };
            } else if (result.isDenied) {
                Swal.fire(
                    'Modificación cancelada',
                    'El campo quedo intacto' ,
                    'succes'
                )
            }
        });
    },
    eliminarEvento: async id => {
        Swal.fire({
            icon: "question",
            title: '¿Esta seguro que desea eliminar el evento?',
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: 'Si',
            denyButtonText: `No`,
        }).then(async (result) => {
            if (result.isConfirmed) {
                ReactDOM.render(
                    <div className='loader_padre'>
                        <Loader />
                    </div>,
                    document.getElementById("loader_padre")
                );

                let url = url_json + "/evento/delete/" + id;
                let request = {
                    method: 'PATCH',
                    headers: {
                        "Content-type": "application/json; charset=UTF-8"
                    }
                }

                let response = await fetch(url, request);
                let res = await response.json();

                ReactDOM.render(
                    <Fragment></Fragment>,
                    document.getElementById("loader_padre")
                );

                if (response.ok) {
                    Swal.fire(
                        'Eliminación exitosa!',
                        'Evento eliminado correctamente' ,
                        'success'
                    ).then(() => {
                        window.location.reload();
                    })
                } else {
                    Swal.fire(
                        'Error!',
                        'No se pudo eliminar el evento' ,
                        'error'
                    ).then(() => {
                        window.location.reload();
                    })
                }
                return { success: response.ok, data: res.data };
            } else if (result.isDenied) {
                Swal.fire(
                    'Eliminación cancelada',
                    'El campo quedo intacto' ,
                    'succes'
                )
            }
        })
    }
}

export default Calendario;
